/// <reference types="office-js" />
/* global Word */
import { useCallback } from 'react';
import { useTemplateStore, getActiveLayoutConfig } from '../store/templateStore';
import type { TemplateProfile, GraphLayoutType, LayoutConfig } from '../../templates/types';
import { readPersistedTemplateId } from '../../word/document/templateMetadata';
import { logger } from '../../core/logging';

/**
 * Hook exposing the active template profile and template helpers.
 */
export function useActiveTemplate(): {
  profile: TemplateProfile;
  setTemplate: (id: string) => void;
  getLayoutConfig: (type: GraphLayoutType) => LayoutConfig;
  syncFromDocument: () => Promise<void>;
} {
  const profile = useTemplateStore((s) => s.activeProfile);
  const setTemplate = useTemplateStore((s) => s.setActiveTemplate);

  const getLayoutConfig = useCallback(
    (type: GraphLayoutType) => {
      const state = useTemplateStore.getState();
      return getActiveLayoutConfig(state, type);
    },
    []
  );

  const syncFromDocument = useCallback(async (): Promise<void> => {
    await Word.run(async (context: Word.RequestContext) => {
      const templateId = await readPersistedTemplateId(context);
      if (templateId) {
        setTemplate(templateId);
        logger.info('Restored template from document metadata', { id: templateId });
      }
    });
  }, [setTemplate]);

  return { profile, setTemplate, getLayoutConfig, syncFromDocument };
}
